<template>
  <!-- 相关案例 -->
  <div>
    <div v-if="type == 1">
      <div class="row row--15 cardlist-body">
        <div
          class="card_list"
          :class="demoClass"
          v-for="(page, index) in demoPages"
          :key="index"
          data-aos="fade-up"
          :data-aos-delay="100 + index"
        >
          <div class="single-demo">
            <router-link :to="page.url">
              <div class="thumbnail">
                <img class="image-dark" :src="page.image" alt="Corporate images" />
                <img class="image-light" :src="page.imageLight" alt="Corporate images" />
              </div>
            </router-link>
            <router-link :to="page.url">
              <div class="card_title">
                <div class="card_title_header w-700">{{ page.title }}</div>
                <div class="card_title_content">{{ page.content }}</div>
                <!-- <div class="card_title_btn">查看详情</div> -->
                <button type="button" class="btn btn-outline-primary card_title_btn">查看详情</button>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="type == 2">
      <div class="row row--15 cardlist-body">
        <swiper class="mySwipes" :options="swiperOption">
          <swiper-slide class="card_list" v-for="(page, index) in demoPages" :key="index">
            <div class="single-demo single-demo-move">
              <router-link :to="page.url">
                <div class="thumbnail">
                  <img class="image-dark" :src="page.image" alt="Corporate images" />
                  <img class="image-light" :src="page.imageLight" alt="Corporate images" />
                </div>
              </router-link>
              <router-link :to="page.url">
                <div class="card_title">
                  <div class="card_title_header w-700">{{ page.title }}</div>
                  <div class="card_title_content">{{ page.content }}</div>
                  <button type="button" class="btn btn-outline-primary card_title_btn">查看详情</button>
                </div>
              </router-link>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
  name: "ListCard",
  components: { swiper, swiperSlide },
  props: {
    type: {
      String,
      default: 1,
    },
    demoPages: {},
    demoClass: "",
  },
  data() {
    return {
      swiperOption: {
        speed: 1000,
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 0,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        observeParents: true,
      },
    }
  },
}
</script>
<style lang="scss" scoped>
.cardlist-body {
  /*.card_list {
    margin: 15px 0;
    .single-demo {
      max-width: 340px;
      max-height: 564px;
      text-align: left;
      margin: 0 auto;
      background: #fff;
      .thumbnail {
        max-width: 340px;
        max-height: 270px;
        border-radius: 0;
      }
      .card_title {
        margin-top: 1.5rem;
        color: #333;
        .card_title_content {
          color: #666;
        }
        .card_title_btn {
          width: 10rem;
          height: 3rem;
          font-size: 12px;
          color: #12294f;
          border: 1px solid #059dff;
        }
        &:hover {
          color: #059dff;
          .card_title_btn {
            background: #059dff;
            color: white;
          }
        }
      }
    }
  }*/
}
</style>
